
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import styles from '../../styles/home/moneyMovesSection.module.scss';
export default function MoneyMovesSection() {
    const imageBlocks = [
        { label: 'THIS', image: '/images/money-moves/image-1.png' },
        { label: 'COULD', image: '/images/money-moves/image-2.png' },
        { label: 'BE', image: '/images/money-moves/image-3.png' },
        { label: 'YOU!', image: '/images/money-moves/image-4.png' },
    ];
    return (<section className={styles.moneyMovesSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className="container">
          <h2 className={styles.title}>Where Liquidity Works Harder</h2>
          <p className={styles.subtitle}>
            Creating a safe environment to grow, trade and benefit from accessible tools and strategies that were not available to the public.
          </p>
          </div>
        </div>

        <div className={styles.imageContainer}>
          {imageBlocks.map((block, index) => (<div key={index} className={styles.imageBlock}>
              <div className={styles.labelContainer}>
                <p className={styles.label}>{block.label}</p>
              </div>
              <div className={styles.imageWrapper}>
                <img src={block.image} alt={block.label} className={styles.image}/>
                <div className={styles.gradient}></div>
              </div>
            </div>))}
        </div>
      </div>
    </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3d9__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//MoneyMovesSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3d9__ as getStaticProps }
  